import React from 'react';
import Comments from '../index';

export default function () {
  return (
    <Comments
      query="/comments?banned=false"
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Comments/Deleted/index.js